<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="所属省区"
                  prop="provinceId"
                >
                  <el-select
                    v-if="eventType!=='view'"
                    v-model="dialogAddEditViewForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="changeProvinceFun"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属城市"
                  prop="cityId"
                >
                  <el-select
                    v-if="eventType!=='view'"
                    v-model="dialogAddEditViewForm.cityId"
                    filterable
                    clearable
                    placeholder="请选择城市"
                    style="width:100%"
                    @change="changeCityFun"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属工业"
                  prop="industrialEnterprisesId"
                >
                  <el-select
                    v-if="eventType!=='view'"
                    v-model="dialogAddEditViewForm.industrialEnterprisesId"
                    filterable
                    placeholder="请选择工业"
                    style="width:100%"
                    @change="changeIndustrialFun"
                  >
                    <el-option
                      v-for="item in industrialOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.industrialEnterprisesName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="品牌名称">
                  <el-input
                    v-model="dialogAddEditViewForm.brandName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="品规名称"
                  prop="name"
                >
                  <el-select
                    v-if="eventType!=='view'"
                    v-model="dialogAddEditViewForm.productId"
                    filterable
                    placeholder="请选择品规"
                    style="width:100%"
                    @change="handleProductChange"
                  >
                    <el-option
                      v-for="item in productDataList"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.name"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最小包库存"
                  prop="minPackage"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.minPackage"
                    :min="0"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最大包库存"
                  prop="maxPackage"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.maxPackage"
                    :min="0"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="最小包价格"
                  prop="minPackagePrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.minPackagePrice"
                    :min="0"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最大包价格"
                  prop="maxPackagePrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.maxPackagePrice"
                    :min="0"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最小条价格"
                  prop="minStripPrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.minStripPrice"
                    :min="0"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最大条价格"
                  prop="maxStripPrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.maxStripPrice"
                    :min="0"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!-- <el-col :span="6">
                  <el-form-item
                    label="标准集市交易价格"
                    prop="basePrice"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.basePrice"
                      :min="0"
                      :precision="2"
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col> -->
              <el-col :span="6">
                <el-form-item
                  label="最小集市交易价格"
                  prop="minPrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.minPrice"
                    :min="0"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最大集市交易价格"
                  prop="maxPrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.maxPrice"
                    :min="0"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最低采集份数"
                  prop="surveyCount"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.surveyCount"
                    :min="0"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="采集显示排序"
                  prop="serial"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.serial"
                    :min="0"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="周报是否统计"
                  required
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.weekReportView"
                    :disabled="eventType==='view'"
                  >
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="月报是否统计"
                  required
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.monthReportView"
                    :disabled="eventType==='view'"
                  >
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col
                v-if="eventType === 'view'"
                :span="6"
              >
                <el-form-item label="状态">
                  <el-radio-group
                    v-model="dialogAddEditViewForm.status"
                    disabled
                  >
                    <el-radio :label="1">
                      启用
                    </el-radio>
                    <el-radio :label="2">
                      禁用
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    style="margin-top:10px;"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { listAreaApi } from '@/api/v2/area';
import { listTobaccoInfoApi } from '@/api/v2/tobaccoInfo';
import { saveSurveyProductSettingApi, viewSurveyProductSettingApi } from '@/api/v2/surveyProductSetting'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        industrialEnterprisesId: [{ required: true, message: '请选择所属工业', trigger: 'change' }],
        basePrice: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        maxPrice: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        minPrice: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        maxPackagePrice: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        minPackagePrice: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        minStripPrice: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        maxStripPrice: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        minPackage: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        maxPackage: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        surveyCount: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' },
          { max: 128, message: '最多输入128个字符', trigger: 'blur' }
        ],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      industrialOptions: [
        { label: '安徽中烟', data: 1 }, { label: '川渝共享', data: 2 }, { label: '福建中烟', data: 3 }, { label: '广东中烟', data: 4 },
        { label: '广西中烟', data: 5 }, { label: '贵州中烟', data: 6 }, { label: '河北中烟', data: 7 }, { label: '河南中烟', data: 8 },
        { label: '湖北中烟', data: 9 }, { label: '湖南中烟', data: 10 }, { label: '江苏中烟', data: 11 }, { label: '江西中烟', data: 12 },
        { label: '山东中烟', data: 13 }, { label: '陕西中烟', data: 14 }, { label: '上海烟草', data: 15 }, { label: '四川中烟', data: 16 },
        { label: '云南中烟', data: 17 }, { label: '浙江中烟', data: 18 }, { label: '中烟国际', data: 19 }, { label: '中烟实业', data: 20 },
        { label: '重庆中烟', data: 21 }
      ],
      productDataList: [],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this;

        _this.provinceOptions = []
        _this.cityOptions = []
        _this.productDataList = [];
        _this.dialogAddEditViewForm = {
          name: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          industrialEnterprisesName: '',
          industrialEnterprisesId: '',
          productId: '',
          brandName: '',
          minPackage: 0,
          maxPackage: 0,
          minPackagePrice: 0,
          maxPackagePrice: 0,
          minStripPrice: 0,
          maxStripPrice: 0,
          basePrice: 0,
          minPrice: 0,
          maxPrice: 0,
          surveyCount: 0,
          serial: 0,
          weekReportView: 1,
          monthReportView: 2,
          remark: '',
          status: 1,
        }
        if (_this.eventType !== 'view') {
          _this.loadProvinceSelectData()
        }

        if (_this.eventType !== 'add') {
          _this.loadProductSettingData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadProductSettingData() {
      let _this = this;
      viewSurveyProductSettingApi({ id: _this.dataId }).then(response => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id

        if (_this.eventType !== 'view') {
          _this.loadCitySelectData(data.provinceId)
          _this.loadTobaccoDataList(data.industrialEnterprisesName);
        }
      })
    },
    // 初始省区下拉数据
    loadProvinceSelectData() {
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun(val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.provinceOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      _this.cityOptions = []
      _this.dialogAddEditViewForm.cityName = ''
      _this.dialogAddEditViewForm.cityId = null
      _this.loadCitySelectData(val)
    },
    // 初始城市下拉数据
    loadCitySelectData(val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun(val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.cityName = selectItem ? selectItem.label : ''
    },
    // 选择工业回调
    changeIndustrialFun(val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.industrialOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.industrialEnterprisesName = selectItem ? selectItem.label : ''
      _this.dialogAddEditViewForm.productId = '';
      _this.dialogAddEditViewForm.brandName = '';
      _this.productDataList = [];
      if (_this.dialogAddEditViewForm.industrialEnterprisesName) {
        _this.loadTobaccoDataList(_this.dialogAddEditViewForm.industrialEnterprisesName);
      }
    },
    // 获取烟草品规选项数据
    loadTobaccoDataList(industrial) {
      listTobaccoInfoApi({ industry: industrial }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.productDataList.push({ label: item.name, data: item.id, brand: item.brand })
        })
      })
    },
    // 烟草品规选项回调
    handleProductChange(val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.productDataList.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.name = selectItem ? selectItem.label : '';
      _this.dialogAddEditViewForm.brandName = selectItem ? selectItem.brand : ''
    },

    // 新增|修改保存
    handleSave() {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '单品调查品规信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            saveSurveyProductSettingApi(_this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.reloadData()
              _this.modalClose()

            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false)
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
